import { eventTracking } from '@/services/event-tracking';

const trackCarSkippedEvent = () => {
  eventTracking.track({
    event: 'Onboarding - Car - Cancel',
  });

  return { type: '#track-car-skipped' };
};

export { trackCarSkippedEvent };
